import { useState } from 'react';
import styled from 'styled-components';
import closed from '../../assets/icons/closedEye.svg';
import opened from '../../assets/icons/openedEye.svg';

const Input = styled.input<{ max: string | number }>`
  width: 100%;
  border: none;
  background: none;
  outline: none;
  font-size: 14px;
  color: ${(props) => props.theme.inputFontColor};
  caret-color: ${(props) => props.theme.colors.neutral900};
  max: ${({ max }) => max && max};
  ::placeholder {
    color: ${(props) => props.theme.inputPlaceholderFontColor};
  }
`;

const InputContainer = styled.div<{ padding: string }>`
  background: ${(props) => props.theme.colors.neutral0};
  border-radius: 100px;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  padding: ${(props) => (props.padding ? props.padding : '0 20px')};
  margin: 0 0 20px 0;
  border: ${(props) => props.theme.inputBorder};
  box-sizing: border-box;
  /* box-shadow: ${(props) => props.theme.inputShadow}; */
  justify-content: space-between;
`;

const InpCont = styled.div<{ val: string }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  :focus-within {
    .lab {
      height: 12px;
      opacity: 0.7;
    }
  }
  ${({ val }) =>
    val
      ? ` .lab {
    height: 12px;
    opacity: 0.7;
  }`
      : ``};
`;

const Label = styled.label`
  font-size: 12px;
  color: #2d2d2d;
  text-transform: uppercase;
`;

const TextArea = styled.textarea`
  width: 100%;
  border: none;
  background: none;
  outline: none;
  z-index: 1;
  font-size: ${({ theme }) => theme.inputFontSize};
  color: ${({ theme }) => theme.inputFontColor};
  caret-color: ${({ theme }) => theme.colors.neutral900};
  height: 100px;
`;

const TextAreaContainer = styled.div`
  background: ${({ theme }) => theme.inputBackground};
  border-radius: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 16px;
  margin: 0 0 20px 0;
  justify-content: space-between;
  border: ${(props) => props.theme.inputBorder};
  /* box-shadow: ${(props) => props.theme.inputShadow}; */
`;

export const InputBackOffice = (props: any) => {
  const [viewPass, setViewPass] = useState(false);
  if (props.type === 'textarea')
    return (
      <TextAreaContainer className={`${props.error && 'shake-input'}`}>
        <InpCont val={props.value}>
          {props.label && <Label className='lab'>{props.label}</Label>}

          <TextArea
            className='inp'
            id={props.id}
            name={props.name}
            value={props.value}
            onChange={(e) => props.onChange(e.target.value)}
            placeholder={props.placeholder}
            style={{ zIndex: 'auto' }}
            rows={props.rows ?? 3}
            disabled={props.disabled}
          />
        </InpCont>
      </TextAreaContainer>
    );

  return (
    <InputContainer
      className={`${props.error && 'shake-input'}`}
      style={props.style}
      padding={props.padding}>
      <InpCont val={props.value}>
        {/* {props.label && <Label className='lab'>{props.label}</Label>} */}

        <Input
          className={'inp'}
          disabled={props.disabled}
          id={props.id}
          type={
            props.type !== 'password'
              ? props.type
              : viewPass
              ? 'text'
              : 'password'
          }
          name={props.name}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
          placeholder={props.placeholder}
          min={props.min}
          max={props.max}
          style={props.inputStyle}
        />
      </InpCont>

      {props.type === 'password' && (
        <img
          src={viewPass ? opened : closed}
          alt='view password'
          onClick={() => setViewPass(!viewPass)}
        />
      )}

      {props.icon && <img src={props.icon} alt='icn' />}
    </InputContainer>
  );
};
